import { createContext, useContext, type ReactNode } from 'react';

export type B2BSurface = 'landing' | 'app';

interface B2BViewContextValue {
  /** `landing` on `/business` and `/business/*`; `app` everywhere else. */
  surface: B2BSurface;
}

const B2BViewContext = createContext<B2BViewContextValue | null>(null);

export function B2BViewProvider({ surface, children }: { surface: B2BSurface; children: ReactNode }) {
  return <B2BViewContext.Provider value={{ surface }}>{children}</B2BViewContext.Provider>;
}

export function useB2BView(): B2BViewContextValue {
  const ctx = useContext(B2BViewContext);
  if (!ctx) {
    throw new Error('useB2BView must be used within B2BViewProvider');
  }
  return ctx;
}

/** Safe for optional use outside the provider (e.g. shared components). */
export function useB2BViewOptional(): B2BViewContextValue | null {
  return useContext(B2BViewContext);
}
